export var LedgerItemType;
(function (LedgerItemType) {
    LedgerItemType["InvestmentResidualCash"] = "INVESTMENT_RESIDUAL_CASH";
    LedgerItemType["InvestmentResidualCashReversal"] = "INVESTMENT_RESIDUAL_CASH_REVERSAL";
    LedgerItemType["InvestmentFrozenCash"] = "INVESTMENT_FROZEN_CASH";
    LedgerItemType["Exit"] = "EXIT";
    LedgerItemType["ExitAmendment"] = "EXIT_AMENDMENT";
    LedgerItemType["Withdrawal"] = "WITHDRAWAL";
    LedgerItemType["RejectedWithdrawal"] = "REJECTED_WITHDRAWAL";
    LedgerItemType["RejectedWithdrawalFee"] = "REJECTED_WITHDRAWAL_FEE";
    LedgerItemType["NewInvestment"] = "NEW_INVESTMENT";
    LedgerItemType["Interest"] = "INTEREST";
    LedgerItemType["Dividend"] = "DIVIDEND";
    LedgerItemType["ManualAdjustment"] = "MANUAL_ADJUSTMENT";
    LedgerItemType["InvestorFee"] = "INVESTOR_FEE";
    LedgerItemType["WithdrawalFee"] = "WITHDRAWAL_FEE";
    LedgerItemType["InvestorDiscount"] = "INVESTOR_DISCOUNT";
    LedgerItemType["Transfer"] = "TRANSFER";
})(LedgerItemType || (LedgerItemType = {}));
//# sourceMappingURL=index.js.map